jQuery(document).ready(function($) {
    /**
     * VetProductReminder
     * A module to handle the "Back in Stock" reminder functionality for WooCommerce products.
     * Supports AJAX submission, client-side validation, and dynamic variation switching.
     */
    const VetProductReminder = {
        /** * @property {jQuery|null} lastClickedButton - Stores the trigger button to apply classes after success. */
        lastClickedButton: null,

        /** * @property {boolean} isProcessing - State flag to prevent closing the popup during an active AJAX request. */
        isProcessing: false,

        /**
         * Initializes the module by binding necessary event listeners.
         * @returns {void}
         */
        init: function() {
            this.bindEvents();
        },

        /**
         * Centralized error message handler.
         * @param {jQuery} $target - The jQuery element to anchor the error.
         * @param {string} message - The translated error message string.
         * @returns {void}
         */
        displayError: function($target, message) {
            $target.parent().find('.error-msg').remove();
            $('<p class="error-msg" style="color: red; margin-top: 10px;">' + message + '</p>')
                .insertAfter($target);
        },

        /**
         * Binds all delegated event listeners to the document.
         * @returns {void}
         */
        bindEvents: function() {
            const self = this;

            // 1. Trigger logic to open the popup
            $(document).on('click', '.out-of-stock-reminder button.product-reminder', function(e) {
                e.preventDefault();
                e.stopPropagation();
                self.handleTriggerClick($(this));
            });

            // 2. AJAX form submission
            $(document).on('submit', '.product-reminder-form', function(e) {
                e.preventDefault();
                self.handleFormSubmit($(this));
            });

            // 3. Close Popups via Close Button
            $(document).on('click', '.vet-pop-up span.close, .vet-pop-up__close-button', function(e) {
                e.preventDefault();

                if (self.isProcessing) {
                    // Find the actual modal box container to shake
                    const $modalBox = $(this).closest('.vet-pop-up__container');
                    self.triggerShake($modalBox);
                    return;
                }

                self.closeActivePopup($(this).closest('.vet-pop-up'));
            });

            // 4. Close Popup on Outside Click
            $(document).on('click', function(e) {
                const $openPopup = $('.vet-pop-up').not('.hide');

                if ($openPopup.length) {
                    const $modalBox = $openPopup.find('.vet-pop-up__container');

                    // If click is outside the white modal container
                    if (!$modalBox.is(e.target) && $modalBox.has(e.target).length === 0) {
                        if (self.isProcessing) {
                            // If loading, trigger the shake instead of closing
                            self.triggerShake($modalBox);
                        } else {
                            self.closeActivePopup($openPopup);
                        }
                    }
                }
            });

            // 5. WooCommerce variation selection hook
            $(document).on('found_variation', function(e, variation) {
                self.handleVariationChange($(e.target), variation);
            });

            // 6. Keyboard Escape key support
            $(document).on('keydown', function(e) {
                if (e.key === "Escape") {
                    const $openPopup = $('.vet-pop-up').not('.hide');
                    if ($openPopup.length) {
                        if (self.isProcessing) {
                            self.triggerShake($openPopup.find('.vet-pop-up__container'));
                        } else {
                            self.closeActivePopup($openPopup);
                        }
                    }
                }
            });
        },

        /**
         * Unified close function to handle state and classes.
         */
        closeActivePopup: function($popup) {
            if (this.isProcessing) return;

            $popup.addClass('hide');

            if ($popup.hasClass('reminder-form__success') && this.lastClickedButton) {
                this.lastClickedButton.addClass('reminded');
            }
        },

        /**
         * Triggers a visual shake animation to indicate the action is blocked.
         */
        triggerShake: function($element) {
            // Remove first in case user clicks rapidly
            $element.removeClass('vet-shake');

            // Force a reflow to allow the animation to restart
            void $element[0].offsetWidth;

            $element.addClass('vet-shake');

            // Remove the class after animation finishes
            setTimeout(function() {
                $element.removeClass('vet-shake');
            }, 400);
        },

        /**
         * Simple regex-based email validation.
         */
        isValidEmail: function(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).toLowerCase());
        },

        /**
         * Handles the initial click on the "Remind Me" button.
         */
        handleTriggerClick: function($btn) {
            this.lastClickedButton = $btn;
            const $container = $btn.closest('.out-of-stock-reminder');

            let $popUp = $btn.next('.reminder-form');
            if (!$popUp.length) $popUp = $container.next('.reminder-form');
            if (!$popUp.length) $popUp = $('.reminder-form').first();

            const explicitVariationId = $btn.attr('data-variation-id');
            const explicitProductId = $btn.attr('data-product') || $btn.attr('data-product-id');

            // Detect variable product context by presence of variation_id input
            const $ctx = $btn.closest('.product, .summary, form').first();
            const $variationIdInput = $ctx.find('input[name="variation_id"]').first();
            const selectedVariationId = $variationIdInput.length ? $variationIdInput.val() : '';

            let idToSend = '';

            // If we are on a variable product page (variation_id input exists),
            // ALWAYS send variation id (never parent id).
            if ($variationIdInput.length) {
                idToSend = explicitVariationId || selectedVariationId;

                if (!idToSend || idToSend === '0') {
                    this.displayError(
                        $btn,
                        (window.product_reminder && product_reminder.choose_variation)
                            ? product_reminder.choose_variation
                            : 'Lūdzu, izvēlieties preces variantu (piemēram, izmēru).'
                    );
                    return;
                }
            } else {
                // Simple product context
                idToSend = explicitProductId;

                if (!idToSend || idToSend === '0') {
                    this.displayError($btn, 'Produkta kļūda.');
                    return;
                }
            }

            $popUp.find('input[name="product_id"]').val(idToSend);

            const $inputs = $popUp.find('input.vet-input');
            $('body').trigger('vetAnimateFormLabels', [ $inputs ]);
            $popUp.removeClass('hide');
        },

        /**
         * AJAX request execution.
         */
        handleFormSubmit: function($thisForm) {
            const self = this;
            const $container = $thisForm.closest('.reminder-form');
            const $spinner = $container.find('.vet-spinner');
            const $submitBtn = $thisForm.find('input[type="submit"]');
            const $closeBtn = $container.find('span.close');

            const productId = $thisForm.find('input[name="product_id"]').val();
            const userEmail = $thisForm.find('input[name="your_email"]').val();

            $thisForm.find('.error-msg').remove();

            if (!productId || productId === "0") {
                this.displayError(
                    $submitBtn,
                    (window.product_reminder && product_reminder.choose_variation)
                        ? product_reminder.choose_variation
                        : 'Lūdzu, izvēlieties preces variantu (piemēram, izmēru).'
                );
                return;
            }

            if (!this.isValidEmail(userEmail)) {
                this.displayError($submitBtn, 'Lūdzu, norādiet derīgu e-pastu.');
                return;
            }

            this.isProcessing = true;
            $spinner.addClass('loaded');
            $submitBtn.prop('disabled', true).css('opacity', '0.5');
            $closeBtn.css('visibility', 'hidden');

            // Support both ajaxurl.url and ajaxurl (string)
            const ajaxEndpoint = (window.ajaxurl && typeof window.ajaxurl === 'string')
                ? window.ajaxurl
                : (window.ajaxurl && window.ajaxurl.url ? window.ajaxurl.url : '');

            $.ajax({
                type: 'POST',
                url: ajaxEndpoint,
                data: {
                    action: 'vet_product_reminder',
                    product_id: productId,
                    email: userEmail,
                    security: product_reminder.nonce
                },
                success: function(response) {
                    self.isProcessing = false;
                    $spinner.removeClass('loaded');
                    $submitBtn.prop('disabled', false).css('opacity', '1');
                    $closeBtn.css('visibility', 'visible');

                    if (response.success) {
                        const $successPopup = $container.next('.reminder-form__success');
                        $successPopup.find('.vet-pop-up__content-message').html(response.data);
                        $container.addClass('hide');
                        $successPopup.removeClass('hide').find('.vet-pop-up__content').addClass('success');
                        $thisForm[0].reset();
                    } else {
                        const msg = response.data || (window.product_reminder ? product_reminder.error : 'Error');
                        self.displayError($submitBtn, msg);
                    }
                },
                error: function() {
                    self.isProcessing = false;
                    $spinner.removeClass('loaded');
                    $submitBtn.prop('disabled', false).css('opacity', '1');
                    $closeBtn.css('visibility', 'visible');
                    self.displayError($submitBtn, 'Servera savienojuma kļūda.');
                }
            });
        },

        /**
         * Updates the UI when a WooCommerce variation is selected.
         */
        handleVariationChange: function(element, variation) {
            const $form = element.closest('form');
            const $reminders = $form.add($form.nextAll('.out-of-stock-reminder, .reminder-form, .reminder-form__success'));

            if (!variation.is_in_stock || !variation.display_price) {
                $form.find('.out-of-stock-reminder').removeClass('hide').find('button').removeClass('reminded');
                $form.next('.out-of-stock-reminder').removeClass('hide');
                $reminders.find('input[name="product_id"]').val(variation.variation_id);
                this.toggleAddToCartUI($form, variation, false);
            } else {
                $reminders.filter('.out-of-stock-reminder, .reminder-form, .reminder-form__success').addClass('hide');
                $form.find('.out-of-stock-reminder').addClass('hide');
                this.toggleAddToCartUI($form, variation, true);
            }
        },

        /**
         * Toggles visibility between Cart UI and Reminder UI.
         */
        toggleAddToCartUI: function($form, variation, show) {
            const $cartItems = $form.find('.quantity, .quantity-sale, .single-product-subimt-button__container');
            const $reminderWrapper = $form.find('.out-of-stock-reminder');

            if (!show || !variation.display_price) {
                $cartItems.hide();
                $reminderWrapper.addClass('bottom');
            } else {
                $cartItems.show();
                $reminderWrapper.removeClass('bottom');
            }

            if (variation.is_on_sale) {
                $form.find('.quantity-sale').hide();
            }
        }
    };


    VetProductReminder.init();
});